import React from 'react';

import { Chip, TooltipHeader } from '@dutchie/backoffice-ui-library';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { BrandRow } from '../shared/types';

export const ConnectionStatusHeader = () => (
  <TooltipHeader
    header="Brand Connection Status"
    iconSize="var(--sizes-30)"
    placement="top"
    tooltip="Brands with an Active status are connected with your stores through the Dutchie Brand Network, as chosen by your administrator."
  />
);

export const ConnectionStatusCell = (
  params: GridRenderCellParams<BrandRow, boolean>,
) => {
  return <div>{params.value ? <ActiveChip /> : <InactiveChip />}</div>;
};

const ActiveChip = () => {
  return (
    <Chip
      $backgroundColor="var(--color-green-10)"
      $color="var(--color-green-80)"
      label="Active"
    />
  );
};

const InactiveChip = () => {
  return (
    <Chip
      $backgroundColor="var(--color-red-10)"
      $color="var(--color-red-60)"
      label="Inactive"
    />
  );
};
